import React, { useEffect } from 'react';
import { compareDate, getCookieData } from '../utilities/utils';
import { useNavigate, useLocation } from 'react-router-dom';
import { deleteCookies } from '../utilities/utils';

const AuthComponent = (components: any) => {
  const navigate = useNavigate();
  const location = useLocation();
  const accountInformation = localStorage.getItem('accountInformation');
  const parsedAccount = accountInformation && JSON.parse(accountInformation);
  const loginDuration = new Date(getCookieData('RefreshCookie'));
  const refreshDuration = new Date(getCookieData('RefreshTokenExpiryCookie'));
  const prevLocation = location.pathname;

  const token = localStorage.getItem('token');
  const pendingMfaAuth = sessionStorage.getItem('pendingMfaAuth');

  useEffect(() => {
    if (parsedAccount?.accountRestricted) {
      navigate('/login', { state: { from: location.pathname } });
      return;
    }

    if (pendingMfaAuth && !token) {
      navigate(`/account/CodeVerification?returnUrl=${prevLocation}`);
      return;
    }

    if (!token) {
      navigate(`/login?returnUrl=${prevLocation}`);
      localStorage.clear();
      sessionStorage.clear();
      deleteCookies();
      return;
    }

    // Restrict Page Builder to Super Admin only
    const userData = JSON.parse(localStorage.getItem('userData') || '{}');

    if (
      location.pathname.startsWith('/admin/page-builder') &&
      userData?.role !== 'Super Admin'
    ) {
      navigate('/admin/dashboard', { replace: true });
      return;
    }
    if (!compareDate(new Date(), loginDuration) && !compareDate(new Date(), refreshDuration)) {
      navigate(`/login?returnUrl=${prevLocation}`);
      localStorage.clear();
      sessionStorage.clear();
      deleteCookies();
    }
  }, [parsedAccount?.accountRestricted, token, pendingMfaAuth]);

  return components;
};

export default AuthComponent;
